module.exports = __webpack_public_path__ + "img/firelite-logo.8841e592.png";